/** editor */
const list = () => import("../../view/jofph/editor/list");
const draft = () => import("../../view/jofph/editor/draft");
const editorAdd = () => import("../../view/jofph/editor/draft/add");
const editorEdit = () => import("../../view/jofph/editor/draft/add");

const model = "/jofph";
const path = model + "/editor";

export default [
  {
    // 草稿箱列表
    path: path + "/draft",
    component: draft,
    name: "editor-draft",
  },
  {
    // 编委列表
    path: path + "/list",
    component: list,
    name: "editor-list",
  },
  {
    // 新增编委
    path: path + "/draft/add",
    component: editorAdd,
    name: "editor-add",
  },
  {
    // 编辑编委
    path: path + "/draft/:editor_id",
    component: editorEdit,
    name: "editor-edit",
  },
];
